import { DividerProps } from '@material-ui/core/Divider';
import {
  createStyles,
  Theme,
  WithStyles,
  withStyles
} from '@material-ui/core/styles';
import classnames from 'classnames';
import * as React from 'react';
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: '1.5rem',
      borderLeft: `1px solid ${theme.palette.text.primary}`,
      margin: '0 1rem'
    }
  });

type IVerticalDividerProps = DividerProps & WithStyles<typeof styles>;

function VerticalDivider(props: IVerticalDividerProps) {
  const { classes, className, ...prop } = props;
  const rootClasses = classnames(classes.root, className);
  return <div {...prop} className={rootClasses} />;
}

export default withStyles(styles)(VerticalDivider);
